// 3rd Party
import styled from 'styled-components';
import { H2, Div, FlexRow } from 'common/styles/oc-styled-components';
import { BREAKPOINTS, colors } from 'common/styles/style-constants';

export const FeatureName = styled(H2)`
  color: ${props => props.crossOut && colors.ash};
  text-decoration: ${props => props.crossOut && 'line-through'};
  line-height: 1.15;
  margin: 0 0 15px 0;
`;

export const FeatureList = styled.ul`
  && {
    display: grid;
    grid-auto-flow: row;
    grid-column-gap: 15px;
    grid-template-columns: repeat(3, calc((100% - 30px) / 3));
    width: 100%;
    padding: 0;
    list-style: none;

    @media (max-width: ${BREAKPOINTS.mobileMax}px) {
      display: block;
      margin: 30px 0;
      padding-left: 20px;
    }
  }
`;

export const ProfileSubsectionHeader = styled(FlexRow)`
  border-bottom: 1px solid ${colors.silver};
  padding-bottom: 10px;
  position: relative;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 30px 0;

  &:after {
    background-color: ${colors.blue};
    border-radius: 50%;
    bottom: -5px;
    content: '';
    display: block;
    height: 10px;
    position: absolute;
    width: 10px;
  }
`;

export const ProfileSubsectionBody = styled(Div)`
  padding: 0 0 0 30px;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    padding: 0;
  }
`;

export const ProfileSubsectionTitle = styled(H2)`
  color: ${colors.charcoal};
  font-size: ${props => props.fontSize || '22px'};
  font-weight: 600;
  margin: 0;
`;

export const ProfileSubsectionDisclaimer = styled.small`
  font-size: 12px;
  text-align: right;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    margin-left: 15px;
  }
`;

export const ProfileReasonName = styled(H2)`
  text-transform: capitalize;
`;
